import React from "react";
import { useAppDispatch, useAppSelector } from "common/hooks/storeHooks";
import { LiveChatWidget } from "@livechat/widget-react";
import { currentUser as currentUserSelector } from "common/selectors/user.selectors";
import { currentUserOrg } from "common/selectors/org.selectors";
import { setupUser } from "common/services/LiveChat.service";

export const LiveChat: React.FC<{}> = () => {
  const currentUser = useAppSelector(currentUserSelector);
  const currentOrg = useAppSelector(currentUserOrg);
  React.useEffect(() => {
    setupUser(currentUser, currentOrg);
  }, [currentUser, currentOrg]);

  return <LiveChatWidget license="17886525" />;
};
